import { HTTP } from '../../http-common'

export default {
  state: {
    loadedEvaporativePlates: []
  },
  getters: {
    loadedEvaporativePlates (state) {
      return state.loadedEvaporativePlates
    }
  },
  mutations: {
    setLoadedEvaporativePlates (state, payload) {
      state.loadedEvaporativePlates = payload
    },
    createEvaporativePlate (state, payload) {
      state.loadedEvaporativePlates.push(payload)
    },
    updateEvaporativePlate (state, payload) {
      state.loadedEvaporativePlates = state.loadedEvaporativePlates.map(evaporativePlate => evaporativePlate.id === payload.id ? payload : evaporativePlate)
    },
    removeEvaporativePlate (state, id) {
      state.loadedEvaporativePlates = state.loadedEvaporativePlates.filter(innerCurtain => {
        return innerCurtain.id !== id
      })
    },
    clearLoadedEvaporativePlates (state) {
      state.loadedEvaporativePlates = []
    }
  },
  actions: {
    loadEvaporativePlates ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedEvaporativePlates', [])

      return new Promise((resolve, reject) => {
        HTTP.get('evaporative_plate_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedEvaporativePlates', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createEvaporativePlate ({ commit, getters }, payload) {
      console.log('createEvaporativePlate')
      commit('clearError')
      commit('setLoading', true)
      const newEvaporativePlate = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('evaporative_plate_type.json/', newEvaporativePlate)
          .then(result => {
            console.log(result)
            commit('createEvaporativePlate', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateEvaporativePlate ({ commit, getters }, payload) {
      console.log('updateEvaporativePlate')
      commit('clearError')
      commit('setLoading', true)
      const evaporativePlate = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`evaporative_plate_type.json/${payload.id}/`, evaporativePlate)
          .then(result => {
            console.log(result)
            commit('updateEvaporativePlate', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeEvaporativePlate ({ commit }, payload) {
      console.log('removeEvaporativePlate')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`evaporative_plate_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeEvaporativePlate', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedEvaporativePlates ({ commit }) {
      commit('clearLoadedEvaporativePlates')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/evaporative_plate/index.js